import { makeRequest } from 'utils/requestLogger';

export default (id, page_number) =>
  makeRequest('get', `/api/courses/${id}/load-messages/${page_number}`);


// WEBPACK FOOTER //
// ./src/app/services/courses/loadMoreMessages.js